import ko from 'knockout';
import moment from 'moment';
import 'moment-duration-format';
import { customFetch as fetch } from '../fetch';

export default class Training {
    id: KnockoutObservable<string>;
    subject: KnockoutObservable<string>;
    date: KnockoutObservable<moment.Moment>;
    durationMs: KnockoutObservable<number>;
    address: KnockoutObservable<string>;
    description: KnockoutObservable<string>;
    userHasSignedUp: KnockoutObservable<boolean>;
    maxNumberOfRegistrations: KnockoutObservable<number>;
    notificationEmail: KnockoutObservable<string>;
    lat: KnockoutObservable<number | null>;
    lng: KnockoutObservable<number | null>;

    duration: KnockoutComputed<string>;
    formattedDate: KnockoutComputed<string>;

    constructor(model: any) {
        this.id = ko.observable<string>(model.id);
        this.subject = ko.observable<string>(model.subject);
        this.date = ko.observable<moment.Moment>(moment(model.date));
        this.durationMs = ko.observable<number>(model.duration);
        this.address = ko.observable<string>(model.address);
        this.description = ko.observable<string>(model.description);
        this.userHasSignedUp = ko.observable<boolean>(model.userHasSignedUp);
        this.maxNumberOfRegistrations = ko.observable<number>(
            model.maxNumberOfRegistrations,
        );
        this.notificationEmail = ko.observable<string>(model.notificationEmail);
        this.lat = ko.observable<number>(model.lat);
        this.lng = ko.observable<number>(model.lng);

        this.duration = ko.pureComputed(
            () =>
                `${moment.duration(this.durationMs(), 'ms').format('H:mm', {
                    trunc: true,
                })} uur`,
        );

        this.formattedDate = ko.pureComputed(() =>
            this.date().format('D MMM YYYY, HH:mm'),
        );
    }

    goToTraining() {
        window.location.href = `/Employee/Training/Detail/${this.id()}`;
    }

    async countMeIn(): Promise<void> {
        const fd = new FormData();
        fd.append('id', this.id());

        const response = await fetch(`/Employee/Training/Register`, {
            method: 'POST',
            body: fd,
        });

        if (response.ok) {
            this.userHasSignedUp(true);
        }
    }
}
